"use client";

import React, { useEffect } from "react";
import { cn } from "@/lib/utils";
import { owners } from "@/helpers/owners";
import { monaSans } from "@/helpers/mona-sans";
import { PageTrademania2Schema } from "@/sanity/pages/PageTrademania2Template";
import { prefersReducedMotion, runScrollFrame } from "@/components/trademania-2/shared";

import Header from "@/components/trademania-2/Header";
import Hero from "@/components/trademania-2/Hero";
import Ticker from "@/components/trademania-2/Ticker";
import Features from "@/components/trademania-2/Features";
import Helmet from "@/components/trademania-2/Helmet";
import System from "@/components/trademania-2/System";
import Why from "@/components/trademania-2/Why";
import Launch from "@/components/trademania-2/Launch";
import Host from "@/components/trademania-2/Host";
import LastCTA from "@/components/trademania-2/LastCTA";
import Footer from "@/components/trademania-2/Footer";

export default function PageTrademania2JSX({ data }: { data: PageTrademania2Schema }) {
  // native scrolling (no smooth scroll); one frame loop drives the scroll-linked sections
  useEffect(() => {
    if (prefersReducedMotion()) return;
    let raf = 0;
    const loop = () => {
      runScrollFrame();
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div
      className={cn(
        "tm2 relative overflow-clip bg-[#F7F8F6] font-geist text-[#0B0C0D]",
        owners.variable,
        monaSans.variable,
      )}>
      {/* Hide the Intercom widget on this launch page; unmounts with the page, so other routes are unaffected. */}
      <style>{`.intercom-lightweight-app, .intercom-app, #intercom-container, #intercom-frame { display: none !important; }`}</style>

      <Header data={data} />
      <main className="-mt-[1rem] pt-[1rem]">
        <Hero data={data} />
        <Ticker items={data?.ticker} />
        <Features data={data} />
        <Helmet data={data} />
        <System data={data} />
        <Why data={data} />
        <Launch data={data} />
        <Host data={data} />
        <LastCTA data={data} />
      </main>
      <Footer data={data} />
    </div>
  );
}
